<script lang="ts">
import { computed, defineComponent } from 'vue'
import { Button as ButtonComponent } from 'beeline-design-system-vue3'

export default defineComponent({
  name: 'CustomButton',
  components: { ButtonComponent },
  props: {
    title: {
      type: String,
      default: '',
    },
    customBtnClass: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    blockClass: {
      type: String,
      default: '',
    },
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const handleClick = (_e: MouseEvent) => {
      emit('click')
    }

    const buttonClass = computed(() => {
      return [
        props.customBtnClass,
        props.isDark ? 'dark-primary-button' : '',
        props.customBtnClass === 'gray-button' && props.isDark
          ? 'dark-gray-button'
          : '',
      ]
    })

    return {
      handleClick,
      buttonClass,
    }
  },
})
</script>

<template>
  <div class="btn-block" :class="blockClass">
    <ButtonComponent :class="buttonClass" :disabled="isDisabled" @on-click="handleClick">
      {{ title }}
    </ButtonComponent>
  </div>
</template>

<style></style>
